// extracted by mini-css-extract-plugin
export default {"root":"styles_root__t2Uq9","container":"styles_container__yujMr","label":"styles_label__cYJ20","input":"styles_input__1sAZp"};